import {
  Component,
  ChangeDetectorRef,
  OnInit,
  Inject,
} from "@angular/core";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule, provideNativeDateAdapter } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CompanyAttributes, DocumentClassAttributes, DocumentRangeAttributes, DocumentTypeAttributes, EmissionPointAttributes } from "@albatrosdeveloper/ave-models-package";
import {
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { ToggleOptionComponent } from "app/shared/components/form-ui/toggle-option/toggle-option.component";
import { EmissionPointService } from "../../emission-point/emission-point.service";
import { DocumentRangeService } from "../document-range.service";
import { DocumentTypeService } from "../../document-type/document-type.service";
import { DocumentClassService } from "../../document-class/document-class.service";
import { IUpdateDocumentRange } from "../interfaces/update-document-range.interface";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { lastValueFrom, take } from "rxjs";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { ICreateDocumentRange } from "../interfaces/create-document-range.interface";


@Component({
  selector: "app-form-document-range",
  templateUrl: "./form-document-range.component.html",
  styleUrls: ["./form-document-range.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatMenuModule,
    MatIconModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatDatepickerModule,
    NgxMatSelectSearchModule,
    FormatOtherDateHourPipe,
    FormSectionComponent,
    ToggleOptionComponent,
    NgxMaskDirective
  ],
  providers: [
    provideNativeDateAdapter(),
    provideNgxMask()
  ]
})
export class FormDocumentRangeComponent implements OnInit {

  documentTypeList: DocumentTypeAttributes[] = [];
  listFilterdocumentTypeList: DocumentTypeAttributes[] = [];
  searchDocumentType = ''
  documentClassList: DocumentClassAttributes[] = [];
  listFilterdocumentClassList: DocumentClassAttributes[] = [];
  searchDocumentClass = ''
  emissionPointList: EmissionPointAttributes[] = [];
  listFilteremissionPointList: EmissionPointAttributes[] = [];
  searchEmissionPoint = ''
  documentRangeList: DocumentRangeAttributes[] = [];
  companyList: CompanyAttributes[] = [];

  validFormR: boolean = false;
  validFormInitial: boolean = false;
  validFormReach: boolean = false;
  validFormDate: boolean = false;
  validFormRange: boolean = false;
  validFormFormat: boolean = false;

  // Lazy loading flags
  documentTypesLoaded = false;
  documentClassesLoaded = false;
  emissionPointsLoaded = false;
  documentRangesLoaded = false;
  valuesLoaded = false;

  form: FormGroup;
  id: string | null = null

  constructor(
    private documentRangeService: DocumentRangeService,
    private readonly companyService: CompanyService,
    private readonly emisionPointService: EmissionPointService,
    private readonly documentTypeService: DocumentTypeService,
    private readonly documentClassService: DocumentClassService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<FormDocumentRangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      code: ['', Validators.required],
      dateTimeStart: [new Date(), Validators.required],
      dateTimeEnd: [new Date(), Validators.required],
      leftFormat: ["", Validators.required],
      rightFormat: "",
      authorizationNumber: null,
      lowerLimit: [0, [Validators.required, Validators.pattern(/^[0-9]*$/),Validators.min(1)]],
      upperLimit: [0, [Validators.required, Validators.pattern(/^[0-9]*$/),Validators.min(1)]],
      initialValue: [0, [Validators.required, Validators.pattern(/^[0-9]*$/),Validators.min(1)]],
      currentValue: [0, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      email: null,
      notifyAfter: [new Date(), Validators.required],
      notifyWhenReachNumber: [0, [Validators.required, Validators.pattern(/^[0-9]*$/),Validators.min(1)]],
      emissionPoint: ["", Validators.required],
      documentType: ["", Validators.required],
      documentClass: ["", Validators.required],
    });
  }

  async ngOnInit() {
    await this.getAllCompany();
    this.ensureFilterDataLoaded();

    if (this.data?._id) {
      this.id = this.data._id
      this.openEditModal(this.data);
    } else {
      this.openCreateModal();
    }
  }

  private async ensureFilterDataLoaded(): Promise<void> {
    await this.fetchAllDocumentType();
    this.fetchAllDocument();
    this.fetchAllEmissionPoint();
    this.fetchAllDocumentRange();
  }

  openCreateModal(): void {
    this.validFormDate = false;
    this.validFormReach = false;
    this.validFormInitial = false;
    this.validFormR = false;
    this.validFormRange = false;
    this.validFormFormat = false;
    this.valuesLoaded = true;
    this.ensureFilterDataLoaded();
    this.form.markAllAsTouched();
  }

  async openEditModal(condition: DocumentRangeAttributes): Promise<void> {
    await this.ensureFilterDataLoaded();
    const selectedDocumentType = condition.documentType?._id
      ? this.documentTypeList.find(
        (payment) => payment._id === condition.documentType._id
      )
      : null;

    const selectedDocumentClass = condition.documentClass?._id
      ? this.documentClassList.find(
        (payment) => payment._id === condition.documentClass._id
      )
      : null;

    const selectedEmissionPoint = condition.emissionPoint?._id
      ? this.emissionPointList.find(
        (payment) => payment._id === condition.emissionPoint._id
      )
      : null;

    const currentUpdateDocumentRange = {
      ...condition,
      documentType:
        selectedDocumentType || condition.documentType,
      documentClass:
        selectedDocumentClass || condition.documentClass,
      emissionPoint:
        selectedEmissionPoint || condition.emissionPoint,
    };

    this.buildform(currentUpdateDocumentRange);
  }

  buildform(data: DocumentRangeAttributes): void {
    this.form.setValue({
      code: data.code,
      dateTimeStart: data.dateTimeStart ? new Date(data.dateTimeStart) : new Date(),
      dateTimeEnd: data.dateTimeEnd ? new Date(data.dateTimeEnd) : new Date(),
      leftFormat: data.leftFormat || '',
      rightFormat: data.rightFormat || '',
      authorizationNumber: data.authorizationNumber || null,
      lowerLimit: Number(data.lowerLimit) || 0,
      upperLimit: Number(data.upperLimit) || 0,
      initialValue: Number(data.initialValue) || 0,
      currentValue: Number(data.currentValue) || 0,
      email: data.email || null,
      notifyAfter: data.notifyAfter ? new Date(data.notifyAfter) : new Date(),
      notifyWhenReachNumber: Number(data.notifyWhenReachNumber) || 0,
      emissionPoint: data.emissionPoint?._id || '',
      documentType: data.documentType?._id || '',
      documentClass: data.documentClass?._id || '',
    });
    this.form.markAllAsTouched();
    this.valuesLoaded = true
  }

  validateLimits() {
    if (!this.valuesLoaded) return null;
    if (!this.form.value) return null;

    const lowerLimit = Number(this.form?.get('lowerLimit')?.value);
    const upperLimit = Number(this.form?.get('upperLimit')?.value);

    if (Number(lowerLimit) >= Number(upperLimit)) {
      this.snackBar.open("El límite inferior no puede ser mayor o igual que el límite superior", "Cerrar", {
        duration: 10000,
        panelClass: ['error-snackbar']
      });
      this.validFormR = true;
    } else {
      this.validFormR = false;
    }
    return null;
  }

  onInitialValue() {
    if (!this.form.value) return null;

    const lowerLimit = Number(this.form?.get('lowerLimit')?.value);
    const upperLimit = Number(this.form?.get('upperLimit')?.value);
    const currentValue = Number(this.form?.get('initialValue')?.value);

    if (currentValue < lowerLimit || currentValue > upperLimit) {
      this.snackBar.open(`El valor inicial debe estar entre ${lowerLimit} y ${upperLimit}`, "Cerrar", {
        duration: 10000,
        panelClass: ['error-snackbar']
      });
      this.validFormInitial = true;
    } else {
      this.validFormInitial = false;
    }

    return null;
  }

  onReachValue() {
    if (!this.form) return null;

    const upperLimit = Number(this.form.get('upperLimit')?.value || '');
    const currentValue = Number(this.form.get('notifyWhenReachNumber')?.value || '');

    if (currentValue > upperLimit) {
      this.snackBar.open(
        `El valor ingresado para notificar cuando alcance (${currentValue.toLocaleString()}) ` +
        `no puede ser mayor que el límite superior (${upperLimit.toLocaleString()})`,
        "Cerrar",
        {
          duration: 10000,
          panelClass: ["error-snackbar"],
        }
      );
      this.validFormReach = true;
    } else {
      this.validFormReach = false;
    }
    return null;
  }

  onDateChange() {
    if (!this.form) return;

    const targetDate = new Date(this.form.get('notifyAfter')?.value || '');
    const startDate = new Date(this.form.get('dateTimeStart')?.value || '');
    const endDate = new Date(this.form.get('dateTimeEnd')?.value || '');

    if (endDate < startDate) {
      this.snackBar.open(
        "La fecha de fin debe ser posterior a la fecha de inicio",
        "Cerrar",
        {
          duration: 10000,
          panelClass: ['error-snackbar']
        }
      );
      this.validFormDate = true;
      return;
    }

    if (targetDate < startDate || targetDate > endDate) {
      this.snackBar.open(
        `Esta fecha debe estar entre fecha de inicio y fecha final`,
        "Cerrar",
        {
          duration: 10000,
          panelClass: ['error-snackbar']
        }
      );
      this.validFormDate = true;
    } else {
      this.validFormDate = false;
    }
  }

  onValueChange() {
    this.validateLimits();
    this.onReachValue();
  }

  isValidEmail(value: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  }

  onSave() {
    if (this.id) {
      this.updateDocumentRange(this.id)
    } else {
      this.createDocumentRange()
    }
  }

  createDocumentRange(): void {
    const formValues = this.form.value;
    const documentRange: ICreateDocumentRange = {
      ...formValues,
      upperLimit: Number(formValues.upperLimit),
      lowerLimit: Number(formValues.lowerLimit),
      initialValue: Number(formValues.initialValue),
      currentValue: Number(formValues.currentValue),
      notifyWhenReachNumber: Number(formValues.notifyWhenReachNumber),
      emissionPointId: formValues.emissionPoint,
      documentTypeId: formValues.documentType,
      documentClassId: formValues.documentClass
    };

    this.documentRangeService
      .create(documentRange)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.dialogRef.close('yes')
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateDocumentRange(id: string): void {
    if (this.form?.value) {
      const updatedDocumentRange: IUpdateDocumentRange = {
        ...this.form.value,
        upperLimit: Number(this.form?.get('upperLimit')?.value),
        lowerLimit: Number(this.form?.get('lowerLimit')?.value),
        initialValue: Number(this.form?.get('initialValue')?.value),
        currentValue: Number(this.form?.get('currentValue')?.value),
        notifyWhenReachNumber: Number(this.form?.get('notifyWhenReachNumber')?.value),
        documentTypeId: this.form?.get('documentType')?.value,
        documentClassId: this.form?.get('documentClass')?.value,
        emissionPointId: this.form?.get('emissionPoint')?.value,
      };

      this.documentRangeService.update(id, updatedDocumentRange).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.dialogRef.close('yes')
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onDocumentTypeSelectionChange(documentTypeId: string): void {
    // Limpiar la selección de clase de documento cuando cambia el tipo
    if (this.form?.get('documentClass')?.value) {
      this.form?.get('documentClass')?.setValue(null);
    }

    // Cargar las clases de documento filtradas por el tipo seleccionado
    if (documentTypeId) {
      this.fetchAllDocument(documentTypeId);
    }

    // Actualizar el ejemplo ya que puede cambiar por el prefijo LD-
    this.onFormatChange();

    // Detectar cambios después de actualizar el tipo de documento
    this.cdr.detectChanges();
  }

  // Métodos para el campo ejemplo
  generateExample(): string {
    const leftFormat = this.form?.get('leftFormat')?.value || '';
    const rightFormat = this.form?.get('rightFormat')?.value || '';
    const isPedido = this.isDocumentTypePedido();

    // Estructura del ejemplo:
    // Normal: FORMATO_IZQ + 8_DIGITOS + FORMATO_DER
    // Pedido: LD- + FORMATO_IZQ + 8_DIGITOS + FORMATO_DER
    const prefix = isPedido ? 'LD-' : '';
    const fixedDigits = '00000000'; // 8 dígitos fijos siempre presentes

    const example = `${prefix}${leftFormat}${fixedDigits}${rightFormat}`;
    return example;
  }

  isDocumentTypePedido(): boolean {
    const documentTypeId = this.form.get('documentType')?.value;
    if (!documentTypeId) return false;

    const docType = this.documentTypeList.find(dt => String(dt._id) === documentTypeId);
    // Verificar si el código o nombre del tipo es PEDIDO
    return docType?.code?.toUpperCase() === DocumentTypeEnum.PEDIDO;
  }

  getMaxCharacters(): number {
    const emissionPointId = this.form?.get('emissionPoint')?.value?.toString() || '';
    const selectedCompany = this.getCompanyFromEmissionPoint(emissionPointId);

    if (selectedCompany?.emissionPointSeriesLength === 0) {
      return Number.MAX_SAFE_INTEGER;
    }

    const result = selectedCompany?.emissionPointSeriesLength || 20; // Default 20 si no se encuentra
    return result;
  }

  getCompanyFromEmissionPoint(emissionPointId: string): CompanyAttributes | undefined {
    const emissionPoint = this.emissionPointList?.find(
      (emissionPoint) => emissionPoint?._id?.toString() === emissionPointId
    );

    const emissionPointCompanyEmbeded = emissionPoint?.company;
    const company = this.companyList?.find(
      (company) => company?._id?.toString() === (emissionPointCompanyEmbeded ? emissionPointCompanyEmbeded?._id?.toString() : '')
    );

    return company;
  }

  validateExampleLength(): boolean {
    const example = this.generateExample();
    const maxLength = this.getMaxCharacters();

    // Si maxLength es 0, es ilimitado
    if (maxLength === 0) return true;
    return example.length <= maxLength;
  }

  onFormatChange(): void {
    if (this.id) {
      this.validFormFormat = !this.validateFormatLengthForUpdate();
    }
    this.cdr.detectChanges();
  }

  validateFormatLength(side: 'left' | 'right'): boolean {
    const maxTotal = this.getMaxCharacters();

    // Si es ilimitado, siempre es válido
    if (maxTotal === 0) return true;

    const leftFormat = this.form.get('leftFormat')?.value || '';;
    const rightFormat = this.form.get('rightFormat')?.value || '';
    const isPedido = this.isDocumentTypePedido();

    // Calculamos los caracteres fijos
    const fixedChars = 8; // 8 dígitos siempre
    const prefixChars = isPedido ? 3 : 0; // "LD-" son 3 caracteres si es PEDIDO

    // Caracteres disponibles para los formatos
    const availableChars = maxTotal - fixedChars - prefixChars;

    if (availableChars <= 0) {
      // No hay espacio para formatos
      return false;
    }

    // Validación específica para cada lado
    if (side === 'left') {
      // Si el formato izquierdo más el mínimo del derecho excede lo disponible
      const maxLeftChars = availableChars - rightFormat.length;
      return leftFormat.length <= maxLeftChars;
    } else {
      // Si el formato derecho más el izquierdo excede lo disponible
      const maxRightChars = availableChars - leftFormat.length;
      return rightFormat.length <= maxRightChars;
    }
  }

  validateFormatLengthForUpdate(): boolean {
    const totalAvailable = this.getMaxAvailableCharsForUpdate();

    // Si es ilimitado, siempre es válido
    if (totalAvailable === 9999) return true;

    const leftFormat = this.form?.get('leftFormat')?.value || '';
    const rightFormat = this.form?.get('rightFormat')?.value || '';

    // Validar que la suma de ambos formatos no exceda los caracteres disponibles
    const totalUsed = leftFormat.length + rightFormat.length;
    const isValid = totalUsed <= totalAvailable;

    return isValid;
  }

  validateSingleFormatLength(side: 'left' | 'right'): boolean {
    const availableForSide = this.getAvailableCharsForSide(side);
    const currentFormat = side === 'left'
      ? (this.form?.get('leftFormat')?.value || '')
      : (this.form?.get('rightFormat')?.value || '');

    return currentFormat.length <= availableForSide;
  }

  getMaxAvailableChars(side: 'left' | 'right'): number {
    const maxTotal = this.getMaxCharacters();

    // Si es ilimitado
    if (maxTotal === 0) return 20; // Máximo individual de 20 caracteres

    const leftFormat = this.form.get('leftFormat')?.value || '';
    const rightFormat = this.form.get('rightFormat')?.value || '';
    const isPedido = this.isDocumentTypePedido();

    // Calculamos los caracteres fijos
    const fixedChars = 8; // 8 dígitos siempre
    const prefixChars = isPedido ? 3 : 0; // "LD-" si es PEDIDO

    // Caracteres disponibles para los formatos
    const availableChars = maxTotal - fixedChars - prefixChars;

    if (side === 'left') {
      return Math.min(20, availableChars - rightFormat.length);
    } else {
      return Math.min(20, availableChars - leftFormat.length);
    }
  }

  getMaxAvailableCharsForUpdate(): number {
    const maxTotal = this.getMaxCharacters();

    // Si es ilimitado, retorna un número alto para indicar sin límite
    if (maxTotal === 0) return 9999;

    const isPedido = this.isDocumentTypePedido();

    // Calculamos los caracteres fijos
    const fixedDigits = 8; // 8 dígitos siempre presentes
    const prefixChars = isPedido ? 3 : 0; // "LD-" si es tipo pedido

    // Caracteres disponibles para distribuir entre formato izquierdo y derecho
    const availableChars = maxTotal - fixedDigits - prefixChars;

    return Math.max(0, availableChars);
  }

  getAvailableCharsForSide(side: 'left' | 'right'): number {
    const totalAvailable = this.getMaxAvailableCharsForUpdate();

    // Si es ilimitado
    if (totalAvailable === 9999) return 50; // Límite razonable por campo

    const leftFormat = this.form?.get('leftFormat')?.value || '';
    const rightFormat = this.form?.get('rightFormat')?.value || '';

    if (side === 'left') {
      // Para el lado izquierdo: disponibles menos lo que ya usa el lado derecho
      return Math.max(0, totalAvailable - rightFormat.length);
    } else {
      // Para el lado derecho: disponibles menos lo que ya usa el lado izquierdo
      return Math.max(0, totalAvailable - leftFormat.length);
    }
  }

  //#region Combos Filter
  async getAllCompany(): Promise<void> {
    try {
      const result = await lastValueFrom(
        this.companyService.findAllWithCount(
          {
            currentPage: 1,
            limitPerPage: Number.MAX_SAFE_INTEGER,
          },
          undefined
        ).pipe(take(1))
      );

      this.companyList = result?.data?.[0]?.data || [];
      this.cdr.detectChanges();
    } catch (err) {
      this.snackBar.open(
        "Error al obtener compañías",
        "Cerrar",
        { duration: 5000, panelClass: ['error-snackbar'] }
      );
    }
  }

  private fetchAllEmissionPoint(): void {
    if (this.emissionPointsLoaded) return;
    this.emissionPointsLoaded = true;

    this.emisionPointService.findToComboBox().subscribe({
      next: (res) => {
        this.emissionPointList = res?.data;
        this.listFilteremissionPointList = this.emissionPointList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener puntos de emisión.", "Cerrar", { duration: 5000 });
      },
    });
  }

  changeOptionsEmissionPoint(event: string) {
    if (!this.emissionPointList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilteremissionPointList = this.emissionPointList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilteremissionPointList = this.emissionPointList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  private fetchAllDocumentType(): Promise<void> {
    if (this.documentTypesLoaded) return Promise.resolve();
    this.documentTypesLoaded = true;

    return new Promise((resolve, reject) => {
      this.documentTypeService.findToComboBox().subscribe({
        next: (res) => {
          this.documentTypeList = res.data;
          this.listFilterdocumentTypeList = this.documentTypeList.slice();
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener tipos de documentos.",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changeOptionsDocumentType(event: string) {
    if (!this.documentTypeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterdocumentTypeList = this.documentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterdocumentTypeList = this.documentTypeList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  private fetchAllDocument(documentTypeId?: string | string[]): void {
    if (!documentTypeId && this.documentClassesLoaded) return;
    if (!documentTypeId) this.documentClassesLoaded = true;

    const idsToFetch = Array.isArray(documentTypeId) ? documentTypeId : documentTypeId ? [documentTypeId] : [];

    this.documentClassService.findToComboBox(idsToFetch).subscribe({
      next: (res) => {
        this.documentClassList = res.data;
        this.listFilterdocumentClassList = this.documentClassList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener clases de documentos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  changeOptionsDocumentClass(event: string) {
    if (!this.documentClassList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterdocumentClassList = this.documentClassList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterdocumentClassList = this.documentClassList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  private fetchAllDocumentRange(): void {
    if (this.documentRangesLoaded) return;
    this.documentRangesLoaded = true;

    this.documentRangeService.findToComboBox().subscribe({
      next: (res) => {
        this.documentRangeList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rango de documentos.", "Cerrar", { duration: 5000 });
      },
    });
  }
  //#endregion
}
